<template>
  <div class="login-container">
    <div class="loginContain">
      <div class="banner" :style="{ backgroundImage: `url(${posters})` }"></div>
      <loginForm
        class="loginForm"
        smsTextColor="#fff"
        :smsBgColor="btnColor"
        :accountType="accountType"
        @loged="handleLoginEvent"
      >
        <div class="icon p" slot="p_icon"></div>
        <div class="icon s" slot="s_icon"></div>
        <div class="loginBtn" :style="{ backgroundColor: btnColor }">
          登录
        </div>
      </loginForm>
      <section
        class="driver-requirement"
        @click="handleRequireMent"
        v-if="isXlDriver"
      >
        了解司机加入要求
        <img class="icon" src="../assets/views/leftpull-icon@2x.png" alt="" />
      </section>
    </div>
    <!-- 司机加盟需求 -->
    <requirement
      id="requirement"
      ref="requirement"
      class="requirement"
      v-if="isXlDriver"
    />
    <div v-if="showRecord">
      <div class="record-wrap">
        <div class="record-line">
          四川神州行网约车服务有限公司 |
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >蜀ICP备2021015471号</a
          >
        </div>
        <div class="record-line record-line2">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52030002001199"
            >蜀公网安备 52030002001199号</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { XL_ACCOUNT_TYPE, USER_TYPE } from '@/utils/constants';
import requirement from '@/components/common/requirement.vue';
import { getUrlParam } from '@/utils';
const preHardCodes = [];
const hardCodes = ['aQbymYvq', 'YvueiANr', ...preHardCodes];
export default {
  props: {
    bannerPoster: {
      required: false,
      type: String
    },
    backgroundColor: {
      required: false,
      type: String
    }
  },
  components: {
    requirement
  },
  methods: {
    handleLoginEvent(...data) {
      this.$emit('login', ...data);
    },
    handleRequireMent() {
      const offsetTop = document.querySelector('#requirement').offsetTop;
      window.scrollTo(0, offsetTop);
    }
  },
  mounted() {
    console.log('login page mounted');
  },
  computed: {
    ...mapState('global', ['accountType', 'env']),
    defaultParams() {
      let isXl = this.accountType === XL_ACCOUNT_TYPE;
      let code = getUrlParam('code'),
        poster = '';
      if (hardCodes.includes(code)) {
        poster = require('../assets/views/login_xl_bg.png');
      } else {
        poster = isXl
          ? require('../assets/views/login_banner_xl.png')
          : require('../assets/views/login_banner.png');
      }
      let color = isXl ? '#ff4553' : '#f16622';
      return {
        poster,
        color
      };
    },
    posters() {
      return this.bannerPoster || this.defaultParams.poster;
    },
    btnColor() {
      return this.backgroundColor && /^#|[rgba?]/.test(this.backgroundColor)
        ? this.backgroundColor
        : this.defaultParams.color;
    },
    // 展示 xl 备案
    showRecord() {
      return this.accountType === XL_ACCOUNT_TYPE;
    },
    isXlDriver() {
      return this.showRecord && this.env == USER_TYPE.driver;
    }
  }
};
</script>

<style lang="less" scoped>
.loginContain {
  width: 750px;
  min-height: 100vh;
  background: rgba(255, 255, 255, 1);
  position: relative;
  overflow: hidden;
  .banner {
    width: 750px;
    height: 400px;
    .bf;
  }
  .icon {
    margin-right: 28px;
    width: 48px;
    height: 48px;
    .bf;
    &.p {
      background-image: url(../assets/views/ic_phone.png);
    }
    &.s {
      background-image: url(../assets/views/ic_login_password.png);
    }
  }
  .loginForm {
    margin-top: 160px;
    /deep/ .inputBox {
      border-bottom: 2px solid rgba(229, 229, 229, 1);
    }

    .loginBtn {
      .fc;
      width: 624px;
      height: 96px;
      opacity: 0.2;
      border-radius: 4px;
      font-size: 32px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    &.canLogin {
      .loginBtn {
        opacity: 1;
      }
    }
  }
  .driver-requirement {
    position: absolute;
    left: 0;
    bottom: 32px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    > .icon {
      margin-left: 9px;
      width: 32px;
      height: 32px;
    }
  }
}
.record-wrap {
  width: 100%;
  font-size: 24px;
  margin-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
  .record-line {
    text-align: center;
  }

  .record-line2 {
    margin-top: 12px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: left center;
    background-image: url('../assets/common/police_icon_1.png');
    padding-left: 28px;
  }
}
</style>
